export const subjectTemplate = [
  'Account',
  'Ads - Advertisement',
  'Customer Service',
  'FAQ',
  'Help Desk',
  'Orders - Your Order(s)',
  'Payment',
  'Report Something Suspicious',
  'Returns & Refund',
  'Shipping Address',
  'Others ..'
];
